import { render, staticRenderFns } from "./declaracaoFormulario.vue?vue&type=template&id=1e4c735c&scoped=true&"
import script from "./declaracaoFormulario.vue?vue&type=script&lang=js&"
export * from "./declaracaoFormulario.vue?vue&type=script&lang=js&"
import style0 from "./declaracaoFormulario.vue?vue&type=style&index=0&id=1e4c735c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4c735c",
  null
  
)

export default component.exports